// Shared across every proposal: the 'Listings by Adam' photo strip.
// Edit here once; every client's page picks it up.

export const listingsByAdam = [
  {
    file: "listings/bellevue-new-construction-twilight-listed-by-adam.webp",
    fileSmall: "listings/bellevue-new-construction-twilight-listed-by-adam-800.webp",
    caption: "Bellevue, listed by Adam",
  },
  {
    file: "listings/kirkland-water-view-listed-by-adam.webp",
    fileSmall: "listings/kirkland-water-view-listed-by-adam-800.webp",
    caption: "Kirkland, listed by Adam",
  },
  {
    file: "listings/bellevue-midcentury-modern-listed-by-adam.webp",
    fileSmall: "listings/bellevue-midcentury-modern-listed-by-adam-800.webp",
    caption: "Bellevue, listed by Adam",
  },
  {
    file: "listings/woodinville-estate-listed-by-adam.webp",
    fileSmall: "listings/woodinville-estate-listed-by-adam-800.webp",
    caption: "Woodinville, listed by Adam",
  },
  {
    file: "listings/kirkland-west-of-market-listed-by-adam.webp",
    fileSmall: "listings/kirkland-west-of-market-listed-by-adam-800.webp",
    caption: "Kirkland, listed by Adam",
  },
  {
    file: "listings/bellevue-blue-home-listed-by-adam.webp",
    fileSmall: "listings/bellevue-blue-home-listed-by-adam-800.webp",
    caption: "Bellevue, listed by Adam",
  },
  {
    file: "listings/kirkland-estate-listed-by-adam.webp",
    fileSmall: "listings/kirkland-estate-listed-by-adam-800.webp",
    caption: "Kirkland, listed by Adam",
  },
];
